import { cn } from '../../lib/utils';

export interface TabItem {
  id: string;
  label: string;
  badge?: string;
  disabled?: boolean;
}

interface TabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (id: string) => void;
  className?: string;
}

export function Tabs({ tabs, activeTab, onTabChange, className }: TabsProps) {
  return (
    <div
      className={cn(
        'flex gap-1.5 bg-card rounded-2xl p-1.5 border border-border shadow-sm',
        className,
      )}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => !tab.disabled && onTabChange(tab.id)}
          disabled={tab.disabled}
          className={cn(
            'flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-150 flex items-center justify-center gap-2',
            tab.disabled
              ? 'opacity-40 cursor-not-allowed hover:bg-transparent'
              : activeTab === tab.id
                ? 'bg-primary text-white shadow-md shadow-primary/20'
                : 'text-muted-foreground hover:text-foreground hover:bg-accent',
          )}
        >
          {tab.label}
          {tab.badge && (
            <span
              className={cn(
                'inline-flex items-center rounded-full px-1.5 py-0.5 text-[11px] font-bold',
                activeTab === tab.id ? 'bg-white/25 text-white' : 'bg-gray-100 text-gray-500',
              )}
            >
              {tab.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
